import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { isDarkTheme } from 'reactApp/appHelpers/featuresHelpers';
import { getIsWorkspaceSuperApp } from 'reactApp/appHelpers/settingsHelpers';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getThemeState = (state: RootState) => state.theme;

const isWorkspaceSuperApp = getIsWorkspaceSuperApp();

export const isCurrentDarkTheme = createSelector(getThemeState, (theme): boolean => {
    if (isWorkspaceSuperApp) {
        return theme.currentTheme === 'dark';
    }

    if (isDarkTheme) {
        return true;
    }

    if (IS_PHONE_BROWSER || !isFeature('theme-switcher')) {
        return false;
    }

    return theme.currentTheme === 'dark';
});
